module.exports = __webpack_public_path__ + "static/media/perio.f146b613.jpg";